import type { ContactCategoryRow, ContactTagRow } from '../types';

const FALLBACK_COLOR = 'bg-slate-500/15 text-slate-300 border-slate-500/25';

interface ContactBadgeProps {
  category: string;
  /** Lista de categorias do tenant (incluindo padrões de plataforma) */
  categories?: ContactCategoryRow[];
}

export function ContactBadge({ category, categories = [] }: ContactBadgeProps) {
  const info = categories.find((c) => c.slug === category);
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${
        info?.color_class ?? FALLBACK_COLOR
      }`}
    >
      {info?.label ?? category}
    </span>
  );
}

interface TagBadgeProps {
  slug: string;
  tags?: ContactTagRow[];
}

export function TagBadge({ slug, tags = [] }: TagBadgeProps) {
  const info = tags.find((t) => t.slug === slug);
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold ${
        info?.color_class ?? FALLBACK_COLOR
      }`}
    >
      {info?.label ?? slug}
    </span>
  );
}

export function EngagementBar({ score }: { score: number }) {
  const pct = Math.min(100, Math.max(0, score));
  const color =
    pct >= 70 ? 'bg-emerald-400' :
    pct >= 40 ? 'bg-amber-400' :
                'bg-red-400';
  return (
    <div className="flex items-center gap-2 min-w-[72px]">
      <div className="h-1.5 flex-grow rounded-full bg-midnight-4 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all ${color}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="font-mono text-[10px] text-ink-subtle w-6 text-right">{pct}</span>
    </div>
  );
}
